import { Button, Steps, Subtitle, Text, Row, Col } from "mondrian-react";
import { isMobile } from "react-device-detect";
import "./style.scss";

import TimerImg from "assets/big-time-icon.svg";
import { reportGA4 } from "utils/pushDataLayer";

const arranjo = [
  {
    icon: "mdn-Icon-pix",
    title: "Pagamento com Pix",
    warning: "O pagamento será confirmado em até 2 horas",
    steps: [
      {
        title: "Início",
        status: "active",
        description: "Você usa a modalidade Pix e paga a fatura",
        width: true,
      },
      {
        title: "Em até 2 horas",
        status: "active",
        description: "A Claro recebe a confirmação bancária",
      },
    ],
  },
  {},
  {
    icon: "mdn-Icon-cartao-de-credito ",
    title: "Pagamento com cartão ou internet banking",
    warning: "O pagamento será confirmado em até 2 dias úteis",
    steps: [
      {
        title: "1º dia",
        status: "active",
        description: "O pagamento é feito e o banco processa o pagamento",
      },
      {
        title: "2º dia",
        status: "active",
        description: "A Claro recebe a confirmação bancária",
      },
    ],
  },
];

function CardOption({ opt }) {
  let divMargin = "";
  let divMarginFooter = "";
  if (Object.keys(opt).length !== 0) {
    divMargin = opt.title.length < 23 && !isMobile ? "divWarningDestaquePix " : "";
    divMarginFooter =
      opt.title.length < 40 && !isMobile ? "divWarningFooterDestaquePix " : "";
  }
  const margin = isMobile ? "divMobileTitle" : ""

  return Object.keys(opt).length === 0 && isMobile ? (
    <div className="mdn-Col-xs-12">
      <div className="divTimerDestaquePixMobile">
        <div className="mdn-Container">
          <div className="mdn-Row removerPaddingDestaquePix">
            <div className="mdn-Col-xs-8 mdn-u-padding--xs mdn-u-marginTop--xxxs zIndexDestaquePix">
              <Text body className="textMobileDestaquePixTimer">
                Você seleciona uma destas formas (Pix, cartão ou internet
                banking), faz o pagamento e depois aguarda o prazo.
              </Text>
            </div>
            <div className="mdn-Col-xs-4 mdn-u-marginTop--xxxs divTimerDestaquePixMobileImg"></div>
          </div>
        </div>
      </div>
    </div>
  ) : Object.keys(opt).length === 0 ? (
    <div className="mdn-Col-xs-12 mdn-Col-lg-3 mdn-u-border divTimerDestaquePix">
      <div className="mdn-Container">
        <div className="mdn-Row">
          <div className="mdn-Col-xs-12 mdn-Col-lg-6 mdn-u-padding--xs mdn-u-marginTop--xxxs">
            <div>
              <img className="mdn-Brand-image" src={TimerImg} alt="" />
            </div>
          </div>
          <div className="mdn-Col-xs-6 mdn-u-padding--xs mdn-u-marginTop--xxxs textTimerDestaquePix ">
            <Text body className="textDestaquePixColor">
              Você seleciona a forma que vai realizar o seu pagamento.
            </Text>
          </div>
        </div>
        <div className="mdn-Row">
          <div className="mdn-Col-xs-12 mdn-u-padding--xs mdn-u-marginTop--xxxs">
            <Text body className="textDestaquePixColor">
              Então o prazo de confirmação vai variar dependendo de como você
              selecionou pagar a sua fatura.
            </Text>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div className="mdn-Col-xs-12 mdn-Col-lg-4">
      <div className="mdn-TopicDetails mdn-TopicDetails--brand">
        <div className="mdn-TopicDetails-group">
          <div className={"mdn-Topic mdn-Topic--horizontal mdn-Topic--sm divIcon " + margin}>
            <div className="mdn-Topic-symbol">
              <span
                className={opt.icon + " mdn-Icon--lg iconCardDestaquePix MarginRightDestaquePix"}
              ></span>
            </div>
            <Subtitle xs className="textIconDestaquePix">
              {opt.title}
              {!isMobile && opt.title === "Pagamento com Pix" ? <><br /><br /></> : null}
            </Subtitle>
          </div>
          {isMobile ? null :
          <div
            className={
              "WarningWidth StepMarginZero mdn-Tag mdn-Tag--feedback alertText " +
              divMargin
            }
          >
            <i className="mdn-Tag-icon mdn-Icon-alerta mdn-Icon--sm"></i>
            <p className="WarningWidth">{opt.warning}</p>
          </div>}
          <div className={divMarginFooter}>
            <Steps className='StepMarginZero divStepIncentivo mdn-u-marginBottom--none' default data={opt.steps} />
          </div>
          <div className="mdn-Row StepMarginDescriptionStep">
            <div className="mdn-Col-xs-5">
              <Text className={opt.steps[0].width ? 'WarningDescriptionPixWidth' : ''} caption>{opt.steps[0].description}</Text>
            </div>
            <div className="mdn-Col-xs-2">
              
            </div>
            <div id='textEnd' className="mdn-Col-xs-5">
              <Text caption>{opt.steps[1].description}</Text>
            </div>
          </div>
          {isMobile ? 
          <div
            className={
              "StepMarginZero mdn-Tag mdn-Tag--feedback mdn-Tag--inverse alertText " +
              divMargin
            }
          >
            <i className="mdn-Tag-icon mdn-Icon-alerta mdn-Icon--sm alertColor"></i>
            <p className="alertColor">{opt.warning}</p>
          </div>:null}
        </div>
      </div>
    </div>
  );
}

export function DestaquePix({ changeNumber }) {
  return (
    <>
      <Row>
        <Col xs={12}>
          <Subtitle sm>
            Em quanto tempo a Claro vai reconhecer o meu pagamento?
          </Subtitle>
        </Col>
      </Row>
      <Row className="mdn-Row">
        <Col xs={12}>
          <Text body className="DescriptionSubTitlePix">
            Entenda o prazo de compensação bancária da sua fatura
          </Text>
        </Col>
      </Row>
      <Row className="mdn-Row mdn-u-justifyContent-xs-between">
        {arranjo.map((opt,i) => (
          <CardOption key={opt.title + i.toString()} opt={opt} />
        ))}
      </Row>
      <Row className="mdn-Row">
        <Col xs={12}>
            <div className="mdn-u-paddingBottom--lg">
              <Button secondary onClick={() => {
                changeNumber()
                reportGA4({customTitle: 'detalhes_de_fatura:voltar'})
              }}>
                Voltar
              </Button>
            </div>
        </Col>
      </Row>
    </>
  );
}
